import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs/operators';
import { environment } from '../environments/environment';

declare const gtag: Function;
@Component({
  selector: 'fcp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Vivest';
  public hjid: number;
  public hjsv: number;

  constructor(
    public router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document
  ){
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-SNQ0FJ30KN', { 'page_path': event.urlAfterRedirects });
      }
    });
  }

  ngOnInit() {
    const appTitle = this.titleService.getTitle();
    const defaultPageTitle = 'Vivest';
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let child = this.activatedRoute.firstChild;
          if (child.snapshot.data.title) {
            return child.snapshot.data.title || defaultPageTitle;
          }
          if (child.snapshot.params.slug) {
            const title = child.snapshot.params.slug;
            var formatTitle = title.split("-");
            for(var i = 0; i < formatTitle.length; i++) {
              formatTitle[i] = formatTitle[i].charAt(0).toUpperCase() + formatTitle[i].substring(1);
            }
            var newTitle = 'Vivest - ' + formatTitle.join(' ');
            return newTitle;
          }
        })
      ).subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
      });
  }

  ngAfterContentInit() {
   if(environment.production) {
      this.hjid = 2995846;
      this.hjsv = 6;
    } else {
      this.hjid = 2996855;
      this.hjsv = 6;
    }

    ((h, o, t, j, a, r) => {
      h.hj =
        h.hj ||
        /* tslint:disable:only-arrow-functions */
       function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid:this.hjid, hjsv:this.hjsv };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window as any, this.document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }
}
